import React, { Component } from 'react';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

class SidebarContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideConvergenceInmailsIndicator: false,
    };
  }

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };

  removeInmailsIndicator = () => {
    this.setState({ hideConvergenceInmailsIndicator: true });
  };

  render() {
    const { data } = this.props;
    const { hideConvergenceInmailsIndicator } = this.state;
    const assetsRootUrl = process.env.REACT_APP_BOTTL_WEBROOT;

    // Obligatoire ainsi, car ne fonctionne pas par props bizarrement
    let user = localStorage.getItem('user');
    if (user) user = JSON.parse(user);

    return (
      <div className="sidebar__content">
        <div className="sidebar__avatar" />
        <ul className="sidebar__block">
          {process.env.DASHBOARD_ENV === 'bottl' ? (
            <React.Fragment>
              <SidebarLink
                icon="home"
                title="Tableau de bord"
                route="/dashboard"
                onClick={this.hideSidebar}
              />
              <SidebarCategory
                image={`${assetsRootUrl}/assets/img/marques/bottl.window-icon.png`}
                title="Bottl.window"
                style={{ color: 'black', fontWeight: 'bold' }}
              >
                {data &&
                  Object.keys(data)
                    .filter((k) => ['campaigns'].includes(k))
                    .map((key) => {
                      const item = data[key];
                      return (
                        <SidebarCategory title={item.label} key={key}>
                          {item.selections && (
                            <SidebarLink
                              title={`${item.selections.label}`}
                              route={`/${item.slug}/selections`}
                              onClick={this.hideSidebar}
                            />
                          )}
                          {item.preparation && (
                            <SidebarLink
                              title={`${item.preparation.label}`}
                              route={`/${item.slug}/preparation`}
                              onClick={this.hideSidebar}
                              newLink={item.preparation.collection.length > 0}
                            />
                          )}
                          <SidebarLink
                            title={`${item.pending.label}`}
                            route={`/${item.slug}/pending`}
                            onClick={this.hideSidebar}
                          />
                          <SidebarLink
                            title={`${item.completed.label}`}
                            route={`/${item.slug}/completed`}
                            onClick={this.hideSidebar}
                          />
                        </SidebarCategory>
                      );
                    })}
                <SidebarLink
                  dist
                  title="Créer une campagne"
                  route="/simulateur"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Pré-sélections proposées"
                  route="/selections"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Liste de simulations"
                  route="/simulations"
                  onClick={this.hideSidebar}
                />

                {data &&
                  Object.keys(data)
                    .filter((k) => ['devis'].includes(k))
                    .map((key) => {
                      const item = data[key];
                      return (
                        <SidebarCategory title={item.label} key={key}>
                          {item.selections && (
                            <SidebarLink
                              title={`${item.selections.label}`}
                              route={`/${item.slug}/selections`}
                              onClick={this.hideSidebar}
                            />
                          )}
                          {item.preparation && (
                            <SidebarLink
                              title={`${item.preparation.label}`}
                              route={`/${item.slug}/preparation`}
                              onClick={this.hideSidebar}
                              newLink={item.preparation.collection.length > 0}
                            />
                          )}
                          <SidebarLink
                            title={`${item.pending.label}`}
                            route={`/${item.slug}/pending`}
                            onClick={this.hideSidebar}
                          />
                          <SidebarLink
                            title={`${item.completed.label}`}
                            route={`/${item.slug}/completed`}
                            onClick={this.hideSidebar}
                          />
                        </SidebarCategory>
                      );
                    })}
              </SidebarCategory>

              <SidebarCategory
                image={`${assetsRootUrl}/assets/img/marques/bottl.data-icon.png`}
                style={{ color: 'black', fontWeight: 'bold' }}
                title="Bottl.data"
                hasBadgeNew
              >
                {/* SUBSCRIBED */}
                {data && data.convergence && data.convergence.is_subscribed && (
                  <>
                    <SidebarCategory
                      title={'Mes dashboards'}
                      href={`${process.env.REACT_APP_ANNONCEURS_NEW_BASE_URL}/dashboards`}
                      dist
                    >
                      <SidebarLink
                        title="Gérer mes indicateurs"
                        route={`${process.env.REACT_APP_ANNONCEURS_NEW_BASE_URL}/indicators`}
                        dist
                      />
                    </SidebarCategory>

                    {/* SUBSCRIBED ON THE HIGHEST PLAN */}
                    {(data.convergence.plan === 'Expert' || true) && (
                      <SidebarCategory title={'Mes études'}>
                        <SidebarLink
                          title="Mes propres études"
                          route={`${process.env.REACT_APP_ANNONCEURS_NEW_BASE_URL}/studies`}
                          dist
                        />
                        {data.convergence.plan !== 'Initial' && (
                          <SidebarLink
                            title="Les études Bottl"
                            route={`${process.env.REACT_APP_ANNONCEURS_NEW_BASE_URL}/bottl-studies`}
                            dist
                          />
                        )}
                      </SidebarCategory>
                    )}

                    <SidebarCategory title={'Mes caves'}>
                      <SidebarLink
                        title="Tableau de bord"
                        route="/data/dashboard"
                        onClick={this.hideSidebar}
                      />
                      <SidebarLink
                        title="Messagerie"
                        route="/data/inmails"
                        onClick={() => {
                          this.removeInmailsIndicator();
                          this.hideSidebar();
                        }}
                        newLink={
                          data &&
                          data.convergence &&
                          data.convergence.inmails_indicator &&
                          !hideConvergenceInmailsIndicator
                        }
                      />
                      <SidebarLink
                        title="Favoris"
                        route="/data/bookmarks"
                        onClick={this.hideSidebar}
                      />

                      <SidebarCategory title={'Mes bases'} key={'Mes bases'}>
                        <SidebarLink
                          title="Gérer"
                          route="/data/intelligence"
                          onClick={() => {
                            this.hideSidebar();
                          }}
                        />
                        <SidebarLink
                          title="Comparer"
                          route="/data/vision"
                          onClick={() => {
                            this.hideSidebar();
                          }}
                        />
                      </SidebarCategory>
                    </SidebarCategory>

                    <SidebarLink
                      title="Plateforme des caves"
                      route={`${process.env.REACT_APP_BOTTL_WEBROOT}/caves/rechercher/`}
                      target="_blank"
                      onClick={() => {
                        this.hideSidebar();
                      }}
                      dist
                    />

                    {data.convergence.plan === 'Expert' && (
                      <SidebarLink
                        title="Ressources"
                        route={`${process.env.REACT_APP_ANNONCEURS_NEW_BASE_URL}/resources`}
                        onClick={this.hideSidebar}
                        dist
                      />
                    )}

                    {/* SUBSCRIBED AND ADMIN */}
                    {data.convergence.is_admin && (
                      <SidebarCategory title="Paramètres">
                        <SidebarLink
                          title="Équipe"
                          route={`${process.env.REACT_APP_ANNONCEURS_NEW_BASE_URL}/team`}
                          onClick={this.hideSidebar}
                          dist
                        />
                        <SidebarLink
                          title="Abonnement"
                          route={`${process.env.REACT_APP_ANNONCEURS_NEW_BASE_URL}/subscription`}
                          onClick={this.hideSidebar}
                          dist
                        />
                      </SidebarCategory>
                    )}
                  </>
                )}

                {/* NOT SUBSCRIBED */}
                {data &&
                  (!data.convergence || !data.convergence.is_subscribed) && (
                    <SidebarLink
                      title="Je m'abonne"
                      route={`${process.env.REACT_APP_BOTTL_WEBROOT}/data`}
                      target="_blank"
                      onClick={() => {
                        this.hideSidebar();
                      }}
                      dist
                    />
                  )}
              </SidebarCategory>

              <SidebarCategory
                image={`${assetsRootUrl}/assets/img/marques/bottl.discover-icon.png`}
                style={{ color: 'black', fontWeight: 'bold' }}
                title="Bottl.discover"
              >
                <SidebarLink
                  title="Créer un site capsule"
                  // route="/brandpages/new"
                  route={`${process.env.REACT_APP_BOTTL_WEBROOT}/brandpages-onboarding/`}
                  target="_blank"
                  onClick={this.hideSidebar}
                  dist
                />
                <SidebarLink
                  title="Liste de mes sites"
                  route="/brandpages/list"
                  onClick={this.hideSidebar}
                />
                {/* <SidebarLink */}
                {/*   title="Abonnement(s)" */}
                {/*   route="/brandpages/subscriptions" */}
                {/*   onClick={this.hideSidebar} */}
                {/* /> */}
              </SidebarCategory>

              {data && data.survey && data.survey.has_studies && (
                <SidebarCategory
                  image={`${assetsRootUrl}/assets/img/marques/bottl.survey-icon.png`}
                  style={{ color: 'black', fontWeight: 'bold' }}
                  title="Bottl.survey"
                >
                  <SidebarLink
                    title="Liste de mes études"
                    route="/survey/studies?for_survey=1"
                    onClick={this.hideSidebar}
                  />
                </SidebarCategory>
              )}

              {user && user.can_see_distributors == true && (
                <>
                  <br />
                  <hr />
                  <SidebarLink
                    title="Distributeurs en France"
                    route="/distributors"
                    onClick={this.hideSidebar}
                  />
                </>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <SidebarLink
                icon="home"
                title="Tableau de bord"
                route="/dashboard"
                onClick={this.hideSidebar}
              />
              <SidebarCategory icon="cog" title="Mes simulations">
                <SidebarLink
                  dist
                  title="Faire une simulation"
                  route="/simulateur"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Pré-sélections proposées"
                  route="/selections"
                  onClick={this.hideSidebar}
                />
                <SidebarLink
                  title="Ma liste de simulations"
                  route="/simulations"
                  onClick={this.hideSidebar}
                />
              </SidebarCategory>
              {data &&
                Object.keys(data).map((key) => {
                  const item = data[key];
                  return (
                    <SidebarCategory
                      icon={item.icon}
                      title={item.label}
                      key={key}
                    >
                      {item.selections && (
                        <SidebarLink
                          title={`${item.selections.label}`}
                          route={`/${item.slug}/selections`}
                          onClick={this.hideSidebar}
                        />
                      )}
                      {item.preparation && (
                        <SidebarLink
                          title={`${item.preparation.label}`}
                          route={`/${item.slug}/preparation`}
                          onClick={this.hideSidebar}
                          newLink={item.preparation.collection.length > 0}
                        />
                      )}
                      <SidebarLink
                        title={`${item.pending.label}`}
                        route={`/${item.slug}/pending`}
                        onClick={this.hideSidebar}
                      />
                      <SidebarLink
                        title={`${item.completed.label}`}
                        route={`/${item.slug}/completed`}
                        onClick={this.hideSidebar}
                      />
                    </SidebarCategory>
                  );
                })}
            </React.Fragment>
          )}
        </ul>
      </div>
    );
  }
}

export default SidebarContent;
